import { Box, Text } from '@chakra-ui/react';
import { PossibleEnrichments } from '@outdoorly/chat-sdk';
import dayjs from 'dayjs';
import React from 'react';

type WorkExperienceProps = {
  qualifications?: NonNullable<NonNullable<PossibleEnrichments['expert']>['expertProfile']>['qualifications'];
};
export const WorkExperience: React.FC<WorkExperienceProps> = (props) => {
  const { qualifications } = props;
  if (!qualifications || !qualifications.length) return <></>;
  return (
    <Box>
      <Text variant="label-small" color="scheme.contentTertiary">
        MY EXPERIENCE
      </Text>
      {qualifications.map((qual) => (
        <Box my="12px" key={qual.id}>
          <Text variant="label-small" color="scheme.contentSecondary">
            {`${dayjs(qual.startDate).format('YYYY')} — ${
              qual.endDate ? dayjs(qual.endDate).format('YYYY') : 'Present'
            }`}
          </Text>
          <Text variant="paragraph-medium" color="scheme.contentPrimary" my="3px" fontWeight={500}>
            {qual.title}
          </Text>
          {qual.description && (
            <Text variant="paragraph-small" color="scheme.contentSecondary">
              {qual.description}
            </Text>
          )}
        </Box>
      ))}
    </Box>
  );
};
